import { publicEnv } from '@/config';

// .env
export const NEXT_PUBLIC_IMAGE_URL = publicEnv.imageUrl;
export const NEXT_PUBLIC_IMAGE_CDN_URL = publicEnv.imageCdnUrl;

// image
export const COVER_LOGIN = 'image/upzi/web/login-page/cover.jpg';
// export const LOGO = 'image/upzi/web/logo/logo.png';
export const LOGO = 'image/upzi/web/logo/logo_header_v4.png';
export const LOGO_FULL_COLOR = 'image/upzi/web/logo/logo-full-color.png';
export const LOGO_EMPOWERED_BY_VNW_WHITE =
  'image/upzi/web/logo/logo-empowered-by-vnw-white.png';
export const MB_LOGO = 'image/upzi/web/logo/mb-logo.png';
export const WARN_ICON = 'image/upzi/web/upload/warning.png';
export const LOADING_BG = 'image/upzi/web/background/loading-bg.jpg';
export const UPZI_LOADING_ICON = 'image/upzi/web/icon/loading-icon.png';
export const UPZI_CV_BUILDER_COVER_01 =
  'image/upzi/web/cv-builder/cover-01-v2.png';
export const UPZI_CV_BUILDER_COVER_02 =
  'image/upzi/web/cv-builder/cover-02-v2.png';
export const UPZI_CV_BUILDER_COVER_03 =
  'image/upzi/web/cv-builder/cover-03-v2.png';
export const UPZI_CV_BUILDER_COVER_04 =
  'image/upzi/web/cv-builder/cover-04-v2.png';
export const UPZI_CV_LOGIN_COVER_BG =
  'image/upzi/web/cv-builder/cover-login-bg.jpg';
export const QR_CODE = '/images/qr_code_landing_page.svg';
/// QR CODE FOR MATCHING JOB
export const QR_CODE_MATCHING_JOB =
  'image/upzi/web/cv-builder/qr_download_matching_job.png';
/// QR CODE FOR DOWNLOAD CV
export const QR_CODE_DOWNLOAD_CV =
  'image/upzi/web/cv-builder/qr_download_cv.png';

// mascot
export const UPZI_MASCOT_BLANK = 'image/upzi/mascot/mascot_blank.png';
export const UPZI_MASCOT_CELEBRATE = 'image/upzi/mascot/mascot_celebrate.png';
export const UPZI_MASCOT_FLIP_TABLE = 'image/upzi/mascot/mascot_flip_table.png';
export const UPZI_MASCOT_LOADING = 'image/upzi/mascot/mascot_loading.png';
export const UPZI_MASCOT_RUN_TO_WORK =
  'image/upzi/mascot/mascot_run_to_work.png';
export const UPZI_MASCOT_EXHAUSTED = 'image/upzi/mascot/mascot_exhausted.png';

// mobile download app
export const UPZI_CV_BUILDER_INSTALLATION_INSTRUCTIONS_APP =
  'image/upzi/web/cv-builder/installation-instructions-app.png';
export const UPZI_CV_BUILDER_INSTALLATION_INSTRUCTIONS_APP_GET_CV =
  'image/upzi/web/cv-builder/installation-instructions-app-get-cv.png';

// cookie
export const UPZI_ACCESS_TOKEN = 'UPZI_ACCESS_TOKEN';
export const UPZI_REFRESH_TOKEN = 'UPZI_REFRESH_TOKEN';
export const UPZI_REFRESH_BACKOFF = 'UPZI_REFRESH_BACKOFF';
export const UPZI_USER_ID = 'UPZI_USER_ID';

export const UPZI_AI_CV_REVIEW_DATA = 'UPZI_AI_CV_REVIEW_DATA';

// link download app
export const URL_PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.navigosgroup.upzi&referrer=utm_source%3Demail%26utm_campaign%3Dnestle_application_1';
export const URL_APP_STORE =
  'https://apps.apple.com/app/apple-store/id6744628248?pt=1608090&ct=email_nestle_application_1&mt=8';

// CV Review, CV Builder Posthog key

export const JS_VIEW_CV_BUILDER_LANDING_PAGE_EVENT_NAME =
  'js_view_cv_builder_landing_page';
export const JS_VIEW_LOGIN_POPUP_EVENT_NAME = 'js_view_login_popup';
export const JS_VIEW_SCREEN_EVENT_NAME = 'js_view_screen';
export const JS_REGISTER_SUCCESS_EVENT_NAME = 'js_register_success';
export const JS_SIGNUP_SUCCESS_EVENT_NAME = 'js_signup_success';
export const JS_LOGIN_SUCCESS_EVENT_NAME = 'js_login_success';
export const JS_LOGOUT_EVENT_NAME = 'js_logout';

export const JS_START_CV_REVIEW_EVENT_NAME = 'js_start_cv_review';
export const JS_VIEW_CV_REVIEW_EVENT_NAME = 'js_view_cv_builder';
export const JS_REWRITE_PROFILE_START_EVENT_NAME = 'js_rewrite_profile_start';
export const JS_REWRITE_PROFILE_SUCCESS_EVENT_NAME =
  'js_rewrite_profile_success';
export const JS_VIEW_PROFILE_EVENT_NAME = 'js_view_profile';
export const JS_EDIT_PROFILE_START_EVENT_NAME = 'js_edit_profile_start';
export const JS_EDIT_PROFILE_EVENT_NAME = 'js_edit_profile';
export const JS_EDIT_PROFILE_CANCEL_EVENT_NAME = 'js_edit_profile_cancel';
export const JS_VIEW_PDF_CV_EVENT_NAME = 'js_view_pdf_cv';
export const JS_DOWNLOAD_PDF_CV_EVENT_NAME = 'js_download_pdf_cv';
export const JS_VIEW_DOWNLOAD_APP_POPUP_EVENT_NAME =
  'js_view_download_app_popup';
export const JS_UPLOAD_FILE_START_EVENT_NAME = 'js_upload_file_start';
export const JS_UPLOAD_FILE_SUCCESS_EVENT_NAME = 'js_upload_file_success';
export const JS_REVIEW_PROFILE_SUCCESS_EVENT_NAME = 'js_review_profile_success';
export const JS_VIEW_OPPORTUNITY_DETAIL_EVENT_NAME =
  'js_view_opportunity_detail';

export {
  CREATOR_CV_SOURCE_SCREENING,
  CV_BUILDER_SOURCE_SCREENING,
  CV_REVIEW_LANDING_PAGE_SOURCE_SCREEN,
  REVIEWER_CV_SOURCE_SCREENING,
} from '@upzi/web-shell/source-screen';

export const REWRITTEN_PROFILE_FLOW = 'rewritten';
export const MANUAL_PROFILE_FLOW = 'manual';
export const REPLACE_ALL_PROFILE_FLOW = 'replace_all';
export const JS_VIEW_POST_DETAIL_EVENT_NAME = 'js_view_post_detail';
export const HIDE_SALARY = 'Lương không công khai';

export const OAUTH_OBJ = {
  ACCESS_TOKEN: 'oauth_access_token',
  EMAIL: 'email',
  GIVEN_NAME: 'given_name',
  FAMILY_NAME: 'family_name',
  REDIRECT_TO: 'redirect_to',
  VERIFIED_EMAIL_USER: 'verified_email_user',
};
// login check
export const UPZI_LOGIN_SUCCESS_EVENT_NAME = 'upzi:login-success';
export const UPZI_LOGOUT_EVENT_NAME = 'upzi:logout';
export const UPZI_SESSION_EXPIRED_EVENT_NAME = 'upzi:session-expired';

export const USER_AGENT_OPPORTUNITY_PAGE = 'upzi-opportunity-page/1.0';
